/*
Copyright (c) 2021.
*/

import maverickPortalhttp from '../../webService/webService';
import maverickPortalApiEndPoint from '../../../config/apiEndPoint';
import AuthService from '../../authService/AuthService';

const  AddNewNoteData =  (data) => {

  return new Promise(function request(resolve) {
    maverickPortalhttp
      .makeRequest(
        maverickPortalApiEndPoint.addNewNote.url,
        maverickPortalApiEndPoint.addNewNote.methodType,
        data
      )
      .then(response => {        
        // if (response.data.Response !== undefined && response.data.Response?.token_data.access_token.length) {
        //    AuthService.login(response.data.Response.token_data.access_token);
        // }
        // else {
        //   console.log(response.data?.Status.StatusDesc)
        // }
        const res = response.data;
        resolve({ res });
      });
  });
};

// const logout = () => {
//   return new Promise(function request(resolve) {
//     AuthService.logout();
//   resolve(true);
//   });
// };

export { AddNewNoteData};
